import styled from '@emotion/styled';

export const Wrapper = styled.div`
  background: var(--white);
  border-radius: 12px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 900px) {
    max-height: 85vh;
  }
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background: var(--white);
  z-index: 10;
  padding: 24px 24px 0 24px;
  border-radius: 12px 12px 0 0;

  @media (max-width: 900px) {
    padding: 16px 16px 0 16px;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px 24px 24px;

  @media (max-width: 900px) {
    padding: 0 16px 16px 16px;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
`;

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  background: var(--white);
  z-index: 10;
  padding: 0 24px 24px 24px;
  border-radius: 0 0 12px 12px;
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;

  @media (max-width: 900px) {
    padding: 16px;
    padding-top: 16px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 300px;
`;

export const HeaderSection = styled.div`
  text-align: center;
  width: 100%;
`;

export const IconWrapper = styled.div`
  font-size: 48px;
  margin-bottom: 16px;

  @media (max-width: 900px) {
    font-size: 40px;
    margin-bottom: 12px;
  }
`;

export const PreviewSection = styled.div`
  width: 100%;
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CheckIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #5636f5;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  button {
    flex: 1;
  }

  @media (max-width: 900px) {
    button {
      width: 100%;
    }
  }
`;
